import { PageHeader } from "@/components/page-header";
import { useT } from "@/lib/i18n";

/**
 * Client wrapper around `PageHeader` so the `/channels` RSC can render
 * i18n labels without the whole page being a client component.
 */
export function ChannelsPageHeader() {
  const t = useT();
  return (
    <PageHeader
      eyebrow={t("common.eyebrow.workspace")}
      title={t("channels.title")}
      subtitle={t("channels.subtitle")}
    />
  );
}
